import { SapiService } from './../../../services/sapi.service';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Observable, interval, Subscription } from 'rxjs';
import { LocationService } from '../../../services/location.service';
import { BbSelectOption } from '../../shared/bb-select/bb-select.component';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { YoutubeCategory } from '../../../shared/models/sapi/youtube-category.model';
import { YoutubeCategoryService } from '../../../services/sapi/youtube-category.service';
import { Social } from './social-details.component';

@Component({
	selector: 'social-details-youtube',
	templateUrl: './social-details-youtube.component.html',
	styleUrls: ['./social-details-youtube.component.scss']
})

export class SocialDetailsYoutubeComponent implements OnInit, OnChanges, OnDestroy {
	@Input() entity: any;

	_entity: Social;

	isDisabled: boolean;
	exportchannelUrl: string;

	authenticationUrl: SafeResourceUrl;

	authorizeWindow: Window;

	checkForWindowTimer: Observable<number>;

	youTubePrivacySettings: BbSelectOption[] = [];
	youtubeCategories: BbSelectOption[] = [];
	ytPlaylistOptions: any[] = [];
	subscriptions = new Subscription();


	constructor(
		private locationService: LocationService,
		private translate: TranslateService,
		private sapiService: SapiService,
		private youtubeCategoryService: YoutubeCategoryService
	) {
		this.youTubePrivacySettings = [];
		this.youTubePrivacySettings.push({ label: this.translate.instant('YOUTUBE_PUBLIC'), value: 'public' });
		this.youTubePrivacySettings.push({ label: this.translate.instant('YOUTUBE_UNLISTED'), value: 'unlisted' });
		this.youTubePrivacySettings.push({ label: this.translate.instant('YOUTUBE_PRIVATE'), value: 'private' });

		this.youtubeCategoryService.list().subscribe((youtubeCategories: YoutubeCategory[]) => {
			if (youtubeCategories) {
				this.youtubeCategories = youtubeCategories as BbSelectOption[];
			}
		});
	}

	ngOnInit() {
		if (this.entity) {
			if (!this.entity.privacy) {
				this.entity.privacy = 'public';
			}
			if (!this.entity.categoryId && this.youtubeCategories.length > 0) {
				this.entity.categoryId = this.youtubeCategories[0].value;
			}
		}
		this.subscriptions.add(this.sapiService.sapiServiceSubject.subscribe((ev) => {
			const thisEntity = ev && ev.entityName === 'exportchannel' && ev.data && ev.data.find(et => this.entity && et.id === this.entity.id);
			if (thisEntity) {
				this.loadYtPlaylists();
			}
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (simpleChanges && simpleChanges.entity && simpleChanges.entity.currentValue) {
			if (this.entity) {
				this.loadYtPlaylists();
			}
		}
	}

	loadYtPlaylists() {
		if (!this.entity) {
			return;
		}
		const url = '/exportchannel/' + this.entity.id + '/playlist';
		this.ytPlaylistOptions = [];

		this.sapiService.getUrl(url).subscribe(data => {
			if (data && data.items && data.items.length) {
				this.ytPlaylistOptions = data.items.map(ytPlaylist => ({
					label: (ytPlaylist.snippet && ytPlaylist.snippet.title) || '',
					value: ytPlaylist.id
				}));
			}
		});
	}

	reauthenticateYoutube() {
		this.isDisabled = true;

		this.authorizeWindow = window.open(this.locationService.server + '/sapi/exportchannel/' + (this.entity.id ? this.entity.id + '/' : '') + 'authorize',
			'authenticate', 'location=0, height=600, width=800');

		this.checkForWindowTimer = interval(1000);
		const windowTimerSubscription = this.checkForWindowTimer.subscribe(() => {
			if (!this.authorizeWindow || (this.authorizeWindow && !this.authorizeWindow.window)) {
				windowTimerSubscription.unsubscribe();
				this.isDisabled = false;
			}
		},
		error => {
			this.isDisabled = false;
		}
		);

	}
}
